import { render } from 'preact'
import { App } from './App';
const domContainer = document.querySelector('#app');
render(<App />,domContainer);